import{palette as t}from"../../../../../../theme/units/palette.js";import{createStyles as e}from"../../../../../../theme/utils/create-styles.js";var r=e({root:{fontSize:"0.31em",fill:t().text.primary,fillOpacity:.55}});export{r as styles};
